import api from "api";

// Recado de pós-venda dos ingressos: o texto configurado e quem recebeu/abriu o
// e-mail de pedido aprovado em que ele vai.
const postSale = {
    get: (slug) => {
        return api().get(`/events/detail/${slug}/post-sale`);
    },

    deliveries: (slug, params) => {
        return api().get(`/events/detail/${slug}/post-sale/deliveries`, { params });
    },
};

export default postSale;
